import { GET_ONE } from 'react-admin';

export default {
  [GET_ONE]: async ({ response, url, options, httpClient, params, apiUrl }) => {
    const itemsUrl = `${url}/items`;

    const items = await httpClient(itemsUrl, { ...options, method: 'GET' })
      .then((r) => r.json)
      .catch(() => []);

    return {
      ...response,
      json: {
        ...response.json,
        items,
      },
    };
  },
};
